import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { GenreService } from './genre.service';
import { TMDBGenre } from '@/core/store/tmdb/tmdb-genre.interface';
const service = new GenreService();

export interface GenreState {
   movieGenres: Array<TMDBGenre>;
   serieGenres: Array<TMDBGenre>;
}

const GenreStore: Module<GenreState, StoreState> = {
   namespaced: true,
   state: {
      movieGenres: [],
      serieGenres: [],
   },
   getters: {},
   mutations: {
      SET_MOVIE_GENRES(state, genres: Array<any>) {
         state.movieGenres = genres;
      },
      SET_SERIE_GENRES(state, genres: Array<any>) {
         state.serieGenres = genres;
      },
   },
   actions: {
      async getMovieGenres({ commit }) {
         const genres = await service.getMovieGenres();
         commit('SET_MOVIE_GENRES', genres);
      },
      async getSerieGenres({ commit }) {
         const genres = await service.getSerieGenres();
         commit('SET_SERIE_GENRES', genres);
      },
   },
};

export default GenreStore;
